import { Component, inject, input } from '@angular/core';
import { UIService } from '@core/ui/ui.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipDirective } from '@shared/directives/tooltip/tooltip.directive';

@Component({
    selector: 'app-navigation-item',
    imports: [TooltipDirective, FontAwesomeModule],
    templateUrl: './navigation-item.component.html',
    styleUrl: './navigation-item.component.scss'
})
export class NavigationItemComponent {
    uiService = inject(UIService);

    name = input<string | undefined>(undefined);
    active = input<boolean>(false);
    licensed = input<boolean|undefined>(undefined);
    isExpanded = input<boolean>(false);
    isCurrent = input<boolean>(false);
}